module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogConfirmaReprovacao),
      callback: function($$v) {
        _vm.dialogConfirmaReprovacao = $$v
      },
      expression: "dialogConfirmaReprovacao"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline font-weight-medium grey lighten-4"
  }, [_vm._v("\n        Confirmação de Reprovação\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('p', {
    staticClass: "text-body-1 mb-4"
  }, [(_vm.projetoSelecionado) ? [_vm._v("\n            Deseja reprovar o relatório do projeto "), _c('strong', [_vm._v(_vm._s(_vm.projetoSelecionado.titulo))]), _vm._v("?"), _c('br'), _c('br'), _vm._v("\n            O(a) coordenador(a) "), _c('strong', [_vm._v(_vm._s(_vm.projetoSelecionado.nomeCoordenador))]), _vm._v(" será suspenso(a) por 1 ano.\n          ")] : [_c('p', [_vm._v("Carregando informações do projeto...")])]], 2), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data de início da suspensão",
      "type": "date",
      "outlined": "",
      "dense": "",
      "required": "",
      "prepend-icon": "event"
    },
    model: {
      value: (_vm.dataInicioSuspensao),
      callback: function($$v) {
        _vm.dataInicioSuspensao = $$v
      },
      expression: "dataInicioSuspensao"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "grey darken-1"
    },
    on: {
      "click": function($event) {
        _vm.dialogConfirmaReprovacao = false
      }
    }
  }, [_vm._v("\n          Não\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "dark": "",
      "disabled": !_vm.dataInicioSuspensao
    },
    on: {
      "click": function($event) {
        return _vm.reprovarRelatorioESuspenderCoordenador(_vm.projetoSelecionado.idProjeto)
      }
    }
  }, [_vm._v("\n          Sim, reprovar\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Reprovação de Relatório com Suspensão de Coordenador'
    }
  }), _vm._v(" "), _c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "filter_list",
      "label": "Filtrar resultados"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaProjetos,
      "search": _vm.search,
      "no-data-text": 'Nenhuma ação',
      "must-sort": "",
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "items-per-page": _vm.itemsPerPage,
      "footer-props": {
        itemsPerPageText: 'Linhas por página',
        itemsPerPageOptions: _vm.opcoesPaginacao
      }
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.titulo",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'ProjetoFormulario',
              params: {
                idProjeto: props.item.idProjeto
              }
            }
          }
        }, [_vm._v(_vm._s(props.item.titulo))])]
      }
    }, {
      key: "item.opcoes",
      fn: function(props) {
        return [_c('c-tooltip-btn', {
          attrs: {
            "icon": "not_interested",
            "color": "red",
            "tooltip": "Reprovar Relatório"
          },
          on: {
            "click": function($event) {
              return _vm.abreDialog(props.item)
            }
          }
        })]
      }
    }, {
      key: "footer.page-text",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n              Mostrando " + _vm._s(pageStart) + " a " + _vm._s(pageStop) + " de " + _vm._s(_vm.listaProjetos.length) + " ações\n            ")]
      }
    }], null, false, 480955877)
  }), _vm._v(" "), _c('br')], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a389290","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/reprovar-relatorios-suspensao-coordenador.vue
// module id = 735
// module chunks = 0